var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCheckSaving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.46698,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#0A8F43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61501 10.148C7.49501 10.148 7.38101 10.1 7.29701 10.016L5.59901 8.31803C5.42501 8.14403 5.42501 7.85603 5.59901 7.68203C5.77301 7.50803 6.06101 7.50803 6.23501 7.68203L7.61501 9.06203L10.699 5.97803C10.873 5.80403 11.161 5.80403 11.335 5.97803C11.509 6.15203 11.509 6.44003 11.335 6.61403L7.93301 10.016C7.84901 10.1 7.73501 10.148 7.61501 10.148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckSaving);
export default __webpack_public_path__ + "static/media/IconsCheckSaving.08437df0db338a4ddd84701d00791e5a.svg";
export { ForwardRef as ReactComponent };